import type { useFormDialog } from './hooks/useFormDialog';
import { BasicInfoTab } from './BasicInfoTab';
import { HistoryTab } from './HistoryTab';

type DialogModel = ReturnType<typeof useFormDialog>;

export const FormHeader = (dialog: DialogModel) => [
  {
    id: 'info',
    label: 'Thông tin',
    component: (
      <div className='overflow-y-auto' onChange={dialog.formState.markDirty}>
        <BasicInfoTab formMode={dialog.formMode} formState={dialog.formState} />
      </div>
    )
  },
  ...(dialog.formMode === 'view'
    ? [
        {
          id: 'history',
          label: 'Lịch sử',
          component: <HistoryTab />
        }
      ]
    : [])
];
